import { options as defaultOptions, createMask } from './overlay.defaults';
import LayoutContainer from './layoutContainer';
export default class Overlay extends LayoutContainer {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this._defaultShow = true;
  }

  renderElement() {
    const instance = this.instance;
    const control = this;
    if (
      (control.isLayoutMode) &&
      !control.designMode.startsWith('overlay-')
    ) {
      return null;
    }

    const options = _.defaultsDeep(this._controlOptions, defaultOptions);

    const path = this.path;
    const firstTime = !control.el;
    const el = super.renderElement();
    if (firstTime) {
      this.maskEl = createMask();
      el.classList.add('overlay');
    }

    if (!this.parentElement.contains(this.maskEl)) {
      this.parentElement.appendChild(this.maskEl);
    }

    this._defaultShow = firstTime || options.revealAnimation === 'none';
    const classes = el.className.split(' ');

    if (!this._defaultShow) {
      if (this.options.originalDisplay) {
        this.el.style.display = this.options.originalDisplay;
        delete this.options.originalDisplay;
      }

      if (this.options.originalOpacity!==undefined) {
        this.el.style.opacity = this.options.originalOpacity;
        delete this.options.originalOpacity;
      }
      // if (firstTime) {
      //   el.style.setProperty('transition-duration', '0s', 'important');
      // } else {
      //   el.style.transitionDuration = '';
      // }

      el.classList.add(options.revealAnimation);
      el.classList.add(options.revealAnimationTiming);
      el.classList.add('mui-enter');
      // console.log(el.style.opacity);
      //el.style.opacity = '';
      // el.style.transitionDuration = '0s';
      if (options.revealAnimationSpeed !== 'normal') {
        el.classList.add(options.revealAnimationSpeed);
      }

      _.delay(() => {
        if (control.visible) {
          el.classList.add('mui-enter-active');
          el.style.opacity = 1;
          el.style.pointerEvents = 'auto';
        } else {
          el.classList.remove('mui-enter-active');
          el.style.opacity = 0;
          el.style.pointerEvents = 'none';
        }

        // el.style.transitionDuration = '';
      }, 20);
    } else {
      _.filter(classes, (cls) => _.startsWith(cls, 'mui-')).forEach((cls) =>
        el.classList.remove(cls)
      );
    }

    if (
      (!control.isLayoutMode && !control.isDesignMode) ||
      _.startsWith(control.designMode, 'overlay-')
    ) {      

      if ((options.mask||options.blurCanvas || options.greyscaleCanvas) && control.visible) {
        
        control.maskEl.classList.add('show');
        if (options.mask && options.maskColor) {
          control.maskEl.style.backgroundColor = options.maskColor;
        }        

        if(options.blurCanvas && options.greyscaleCanvas){
          control.maskEl.classList.add('dim-fast-backdrop');
        }else if(options.blurCanvas){
          control.maskEl.classList.add('blur-fast-backdrop');
        }else if(options.greyscaleCanvas){
          control.maskEl.classList.add('bw-fast-backdrop');
        }

      } else {
        control.maskEl.classList.remove('show');
        if (options.maskColor) {
          control.maskEl.style.backgroundColor = null;
        }

        control.maskEl.classList.remove('dim-fast-backdrop');
        control.maskEl.classList.remove('blur-fast-backdrop');
        control.maskEl.classList.remove('bw-fast-backdrop');

        
      }

      const anyOverlay = _.some(instance.controls, (c)=>c.type==='overlay'&&c.visible && (c.options.mask||c.options.blurCanvas || c.options.greyscaleCanvas));

      if(anyOverlay){
        instance.options.controls.forEach((c, i) => {
          if (c.type !== 'overlay') {
            // _.defer(()=>{
            if(instance.controls[`controls[${i}]`]){
              instance.controls[`controls[${i}]`].setMasked(true);
            }
            // });
          }
        });

        instance.maskCanvas(true);
      }else if(instance.controls){
        instance.options.controls.forEach((c, i) => {
          if (c.type !== 'overlay') {
            // _.defer(()=>{
            if(instance.controls[`controls[${i}]`]){
              instance.controls[`controls[${i}]`].setMasked(false);
            }
            // });          
          }
        });

        instance.maskCanvas(false);
      }
    }

    return el;
  }
}
